module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-drawer', {
    attrs: {
      "title": "卡片详情",
      "visible": _vm.visible,
      "direction": "rtl",
      "before-close": _vm.handleClose,
      "custom-class": "c-drawer",
      "size": "45%"
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.formLoading),
      expression: "formLoading"
    }],
    ref: "formRef",
    attrs: {
      "model": _vm.formInfo,
      "rules": _vm.formRules,
      "label-position": "right",
      "size": "small",
      "label-width": "120px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "权益卡名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "name", $$v)
      },
      expression: "formInfo.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "权益卡类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.type),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "type", $$v)
      },
      expression: "formInfo.type"
    }
  }, _vm._l((_vm.cardTypeOptions), function(item) {
    return _c('el-option', {
      key: Number(item.value),
      attrs: {
        "label": item.label,
        "value": Number(item.value)
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "价格/元",
      "prop": "price"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "clearable": "",
      "min": 1
    },
    model: {
      value: (_vm.formInfo.price),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "price", $$v)
      },
      expression: "formInfo.price"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "折扣",
      "prop": "discount"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls-position": "right",
      "precision": 2,
      "clearable": "",
      "max": "1",
      "min": 0
    },
    model: {
      value: (_vm.formInfo.discount),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "discount", $$v)
      },
      expression: "formInfo.discount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "有效时间/天",
      "prop": "validity"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls-position": "right",
      "clearable": "",
      "min": 1
    },
    model: {
      value: (_vm.formInfo.validity),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "validity", $$v)
      },
      expression: "formInfo.validity"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "权益",
      "prop": "privilegesList"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "multiple": "",
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.privilegesList),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "privilegesList", $$v)
      },
      expression: "formInfo.privilegesList"
    }
  }, _vm._l((_vm.privilegeList), function(item) {
    return _c('el-option', {
      key: item.id + '',
      attrs: {
        "label": item.name,
        "value": item.id + ''
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "说明",
      "prop": "description"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "textarea",
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.description),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "description", $$v)
      },
      expression: "formInfo.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.formInfo.status),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "status", $$v)
      },
      expression: "formInfo.status"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: Number(item.value),
      attrs: {
        "label": item.label,
        "value": Number(item.value)
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "editOpera-seat"
  }), _vm._v(" "), _c('div', {
    staticClass: "drawer-footer"
  }, [_c('div', {
    staticClass: "operation"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("保存")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-51800e81","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/privilege/card/components/info.vue
// module id = 1667
// module chunks = 0